import { render, staticRenderFns } from "./FollowUpFilters.vue?vue&type=template&id=5a6a0138&scoped=true&"
import script from "./FollowUpFilters.vue?vue&type=script&lang=js&"
export * from "./FollowUpFilters.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpFilters.vue?vue&type=style&index=0&id=5a6a0138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a0138",
  null
  
)

export default component.exports